var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTpmessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.931 6.04269V15.5417C23.931 17.5635 22.3484 19.2158 20.3545 19.3274L20.1393 19.3334H4.38932C2.36745 19.3334 0.715198 17.7508 0.603653 15.7568L0.597656 15.5417V6.04269L11.8583 11.9418C12.1127 12.0749 12.416 12.0749 12.6703 11.9418L23.931 6.04269ZM4.38932 0.666687H20.1393C22.1048 0.666687 23.7211 2.16225 23.9121 4.0775L12.2643 10.1789L0.616545 4.0775C0.800493 2.23318 2.30603 0.778045 4.17243 0.672789L4.38932 0.666687Z",
    fill: "#ABB1BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpmessage);
export default __webpack_public_path__ + "static/media/tpmessage.55150de6db67a1bf6d591aa5557fe299.svg";
export { ForwardRef as ReactComponent };